import { takeLatest, put, call } from 'redux-saga/effects';

import { listTabelaTributaria } from '../service';
import {
  TABLE_TABELA_TRIBUTARIA,
  TABLE_TABELA_TRIBUTARIA_PENDING,
  TABLE_TABELA_TRIBUTARIA_SUCCESS,
  TABLE_TABELA_TRIBUTARIA_FAILURE
} from '../actionTypes';

function* sagaListTabelaTributaria(action) {
  yield put({ type: TABLE_TABELA_TRIBUTARIA_PENDING })

  try {
    const table = yield call(listTabelaTributaria, action.args)
    yield put({ type: TABLE_TABELA_TRIBUTARIA_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_TABELA_TRIBUTARIA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListTabelaTributaria() {
  yield takeLatest(TABLE_TABELA_TRIBUTARIA, sagaListTabelaTributaria)
}